import { FetchOptions } from './types';

type SerializableRequestOptions = {
    method?: string;
    body?: Record<string, unknown>;
    mode?: string;
};

export class HttpError extends Error {
    readonly requestUrl: string;
    readonly requestOptions: SerializableRequestOptions;
    readonly responseStatus: number;
    readonly responseBody: unknown;

    constructor(params: {
        requestUrl: string;
        requestOptions: FetchOptions;
        responseStatus: number;
        responseBody: unknown;
    }) {
        const { requestUrl, requestOptions, responseStatus, responseBody } =
            params;
        super(`Failed to fetch ${requestUrl}: ${responseStatus}`);
        this.name = 'HttpError';
        this.requestUrl = requestUrl;
        this.requestOptions = this.toSerializableRequestOptions(
            requestOptions || {}
        );
        this.responseStatus = responseStatus;
        this.responseBody = responseBody;
    }

    private toSerializableRequestOptions(
        requestOptions: FetchOptions = {}
    ): SerializableRequestOptions {
        return {
            method: requestOptions.method,
            mode: requestOptions.mode,
        };
    }

    static isNotFoundError(error: unknown): error is HttpError {
        return error instanceof HttpError && error.responseStatus === 404;
    }
}
